import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const XRepostTriggerDetails = ({ trigger, triggerType }: Props) => {
  const postId = useMemo(() => {
    if (trigger.context?.postId) {
      return trigger.context.postId;
    }
    if (!trigger.signature) return '';
    const match = trigger.signature.match(/^x-verify-retweet-(\d+)$/);
    return match ? match[1] : '';
  }, [trigger.context?.postId, trigger.signature]);

  const postUrl = useMemo(() => {
    if (!/^\d+$/.test(postId)) return '';
    return `https://x.com/i/status/${postId}`;
  }, [postId]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      {postUrl && <TriggerExternalLinkDetail label="Post" value="View post" href={postUrl} />}
    </div>
  );
};
